import { render, staticRenderFns } from "./ageCheck.vue?vue&type=template&id=dfb55596&scoped=true&"
import script from "./ageCheck.vue?vue&type=script&lang=js&"
export * from "./ageCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb55596",
  null
  
)

/* custom blocks */
import block0 from "./ageCheck.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports